import client from "api/client";
import type { UserCampaignInfoApi } from "api/models/campaigns";

import type { ClearAccount, UpdateUser, UserBasicApi, UserInfoApi } from "api/models/user";


const base = "/admin/user";
const user = {
	get: (userId: number) => client.post<UserInfoApi>(base + "", { userId }),
	clear: (body: ClearAccount) => client.post<UserInfoApi>(base + "/clear", body),
	edit: (body: UpdateUser) => client.post<UserInfoApi>(base + "/edit", body),
	search: (search: string) => client.post<UserBasicApi[]>(base + "/search", { search }),
	getCampaigns: (userId: number) => client.post<UserCampaignInfoApi[]>(base + "/campaigns", { userId }),
	unredeemCampaign: (userId: number, campaignId: number) => client.post<UserCampaignInfoApi[]>(base + "/campaign/unredeem", { userId, campaignId })
};

export default user;